/* MarieOdile productcarrousel.
   Sectie-gescoped, idempotent, en bestand tegen Theme Editor section reloads.
   Meerdere instanties op één pagina werken onafhankelijk. */
(function () {
  'use strict';

  function initShelf(shelf) {
    if (!shelf || shelf.dataset.moInit === '1') return;
    shelf.dataset.moInit = '1';

    var track = shelf.querySelector('[data-mo-track]');
    var viewport = shelf.querySelector('[data-mo-viewport]');
    var cards = shelf.querySelectorAll('[data-mo-card]');
    var prev = shelf.querySelector('[data-mo-prev]');
    var next = shelf.querySelector('[data-mo-next]');
    var counter = shelf.querySelector('[data-mo-current]');
    if (!track || !viewport || !cards.length) return;

    var index = 0;

    function step() {
      var a = cards[0].getBoundingClientRect();
      if (cards.length < 2) return a.width;
      return cards[1].getBoundingClientRect().left - a.left;
    }
    function maxIndex() {
      var s = step();
      if (!s) return 0;
      return Math.max(0, cards.length - Math.max(1, Math.floor(viewport.clientWidth / s)));
    }
    function apply() {
      index = Math.min(Math.max(index, 0), maxIndex());
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
      if (counter) counter.textContent = index + 1;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
    }

    function onPrev() { index -= 1; apply(); }
    function onNext() { index += 1; apply(); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    var t;
    function onResize() { clearTimeout(t); t = setTimeout(apply, 150); }
    window.addEventListener('resize', onResize);

    /* opruimen zodat een section reload geen dubbele listeners achterlaat */
    shelf.moDestroy = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      window.removeEventListener('resize', onResize);
      shelf.dataset.moInit = '';
    };

    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-mo-shelf]').forEach(initShelf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme Editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mo-shelf]').forEach(function (s) {
      if (typeof s.moDestroy === 'function') s.moDestroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest('[data-mo-card]');
    var shelf = e.target.closest('[data-mo-shelf]');
    if (!card || !shelf) return;
    var cards = [].slice.call(shelf.querySelectorAll('[data-mo-card]'));
    var i = cards.indexOf(card);
    var nextBtn = shelf.querySelector('[data-mo-next]');
    if (i < 0 || !nextBtn) return;
    /* scroll het geselecteerde blok in beeld */
    for (var n = 0; n < i && !nextBtn.disabled; n++) nextBtn.click();
  });
})();
